module.exports = __webpack_public_path__ + "static/dmn-logo-1b04dcec01ab435a0a9acc8d26cf1915.png";